import React from 'react';
import { CustomArticleSlugTypes } from 'types/global';
import { Message } from 'components/elements';
import { PageWrapper } from 'components/presentional';
import { usePages } from 'hooks';
import { useRouteTranslations } from 'utils';
import { WPAcfThankYou } from 'types/acf';
import { WPSimplePage } from 'types/pages';

const ThankYouPage = () => {
  const THANK_YOU_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'thank_you';
  const { translateSlug } = useRouteTranslations();
  const { data: page, loading } = usePages<WPSimplePage<WPAcfThankYou>>({ slug: translateSlug(THANK_YOU_PAGE_SLUG_TYPE) });
  const [customPage] = page || [];

  if (!customPage) {
    return null;
  }

  const {
    acf: { message },
  } = customPage;

  return (
    <PageWrapper title={customPage?.yoast_title} meta={customPage?.yoast_meta} loading={loading} name={THANK_YOU_PAGE_SLUG_TYPE}>
      {message && <Message data={message} />}
    </PageWrapper>
  );
};

export default ThankYouPage;
